// https://m.media-amazon.com/images/I/51cWp9MJZTL._SL1000_.jpg

import { useEffect } from "react";
import { SpotToast } from "@/components/SpotToast";

export const ToastProvider = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.SpotToast = SpotToast;
    }
  }, []);

  return null;
};
